import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import searchReducer from './slices/searchSlice';
import resultsReducer from './slices/resultsSlice';
import emailVerificationReducer from './slices/emailVerificationSlice';
import dmUnlockReducer from './slices/dmUnlockSlice';
import balanceReducer from './slices/balanceSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    search: searchReducer,
    results: resultsReducer,
    emailVerification: emailVerificationReducer,
    dmUnlock: dmUnlockReducer,
    balance: balanceReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 